import * as $ from 'pumpkin.js'

export default function ($el, options) {
  const $updatePrices = $.qsa('.js-update-price')
  const $pices = $.qsa('.js-price')

  const updatePrice = function () {
    const $el = this

    if ($el.checked) {
      const weeks = $el.getAttribute('data-weeks')

      $pices.forEach($price => {
        $price.classList[
          $price.getAttribute('data-weeks') === weeks ? 'remove' : 'add'
        ]('hidden')
      })
    }
  }

  $updatePrices.forEach($updatePrice => {
    $updatePrice.addEventListener('change', updatePrice)
  })
}
